import React from "react";
import PropTypes from "prop-types";
import {getDefaultFieldLabel} from "../../../../utilities/helperFunctions";
import SelectChipContainer from "../../../../connectui/component/input/SelectChipContainer";
import BaseFieldComponent from "../BaseFieldComponent";

const GuestVerificationStatusField = ({
  fieldData,
  handleValueChange,
  options,
  ...props
}) => {
  const renderInput = () => (
    <SelectChipContainer
      options={options}
      selectedOptions={fieldData?.val}
      onChange={(newSelection) => {
        handleValueChange(
          fieldData.type,
          Array.isArray(newSelection)
            ? newSelection.filter((f) => f !== "")
            : newSelection,
        );
      }}
      multiSelect={false}
    />
  );

  const getDisplayValue = () => {
    if (!fieldData?.val || !fieldData?.operators) return null;
    const value = Array.isArray(fieldData.val)
      ? fieldData.val[0]
      : fieldData.val;
    const operator = Array.isArray(fieldData.operators)
      ? fieldData.operators[0]
      : fieldData.operators;
    return value === "Verified" && operator === "=="
      ? "Verified"
      : value === "Verified" && operator === "!="
        ? "Unverified"
        : null;
  };

  const renderFilter = () => (
    <SelectChipContainer
      options={options}
      selectedOptions={getDisplayValue() ? [getDisplayValue()] : []}
      onChange={(newSelection) => {
        if (newSelection.length === 0) {
          handleValueChange("custom", []);
        } else {
          handleValueChange(
            "custom",
            newSelection.map((selection) => ({
              path: fieldData.field,
              operator: selection === "Verified" ? "==" : "!=",
              value: "Verified",
            })),
          );
        }
      }}
      multiSelect={false}
    />
  );

  const getOperators = () => [
    "contains",
    "not_contains",
    "exists",
    "not_exists",
    "is_one_of",
  ];

  const getLabel = () =>
    getDisplayValue() || getDefaultFieldLabel(fieldData?.val);

  return (
    <BaseFieldComponent
      renderInput={renderInput}
      renderFilter={renderFilter}
      getLabel={getLabel}
      getOperators={getOperators}
      {...props}
    />
  );
};

GuestVerificationStatusField.propTypes = {
  fieldData: PropTypes.object.isRequired,
  handleValueChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
};

export default GuestVerificationStatusField;
